<template>
    <div class="pagination-footer">
        <div class="pagination">
            <span>Cтраница:</span>
            <div class="pagination_prev" @click.prevent="prevPage(params)">
                <svg width="8" height="16" viewBox="0 0 8 16" fill="none">
                    <path id="shape" fill-rule="evenodd" clip-rule="evenodd" d="M0.269108 8.64968L6.70064 15.0812L8 13.7818L2.21815 8L8 2.21815L6.70064 0.918787L0.269108 7.35031C-0.0897023 7.70912 -0.0897023 8.29087 0.269108 8.64968Z" fill="#878A91"/>
                </svg>
            </div>
            <div
                v-for="(item, key) in totalRecords"
                :key="key"
                class="pagination_number"
                :class="{ 'active': item === params.currentPage + 1 }"
                @click.prevent="nextTo(params, item-1)"
            >
                {{ item }}
            </div>
            <div class="pagination_next" @click.prevent="nextPage(params)">
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="16">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.73089 8.64965L1.29936 15.0812L-5.6797e-08 13.7818L5.78185 7.99997L-5.62262e-07 2.21812L1.29936 0.918756L7.73089 7.35028C8.0897 7.70909 8.0897 8.29084 7.73089 8.64965Z" fill="#878A91"/>
                </svg>
            </div>
        </div>
        <div class="select-list">
            <span>Выводить:</span>
            <div class="select-list_drop">
                <v-select
                    :items="pageSizes"
                    outlined
                    item-text="name"
                    item-value="size"
                    dense
                    hide-details
                    v-model="params.pageSize"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        pageSize: { type: Number, default: () => 5 },
        currentPage: { type: Number, default: () => 1 },
        totalRecords: { type: Number, default: () => 1 },
        nameUrl: { type: String, default: () => '' },
        nameLoad: { type: String, default: () => '' },
        nameParams: { type: String, default: () => '' }
    },
    data: () => ({
        pageSizes: [
            { name: '5', size: 5 },
            { name: '10', size: 10 },
            { name: '15', size: 15 },
            { name: 'Все', size: 999999 }
        ],
        params: {
            pageSize: 5,
            currentPage: 0
        }
    }),
    watch: {
        'params.pageSize'(val) {
            this.params.pageSize = val;
            this.updatePageSize(this.params, val);
        }
    },
    methods: {
        get(params) {
            this.$emit('query', {
                nameLoad: this.nameLoad,
                nameUrl: this.nameUrl,
                nameParams: this.nameParams,
                ...params
            });
        },
        updatePageSize(params, size) {
            if(size === 'Все') size = this.totalRecords;
            params.currentPage = 0;

            this.get(params);
        },
        prevPage(params) {
            if (params.currentPage > 0) {
                params.currentPage--;
                
                this.get(params);
            }
        },
        nextPage(params) {
            if (params.currentPage < (this.totalRecords - 1)) {
                params.currentPage++;
                this.get(params);
            }
        },
        nextTo(params, page) {
            // console.log(page);
            if(page === params.currentPage) {
                return;
            }
            params.currentPage = page;
            this.get(params);
        }
    }
}
</script>

<style src="./index.scss" lang="scss" scoped />